import { Fragment } from "react";
import {
  Input,
  Button,
  Checkbox,
  Switch,
  Select,
  Option,
} from "@material-tailwind/react";
import { FaCopy } from "react-icons/fa";
import "./formBuilder.css";
// Form Elements
import { formEl } from "../constants";
import uuid from "react-uuid";
import { FiPlusCircle } from "react-icons/fi";
import { IoMdRemoveCircleOutline } from "react-icons/io";

const CheckBoxInput = ({
  item,
  index,
  handleValue,
  deleteEl,
  handleRequired,
  handleElType,
  duplicateElement,
  handleSave,
  addOption,
  handleOptionValues,
  deleteOption,
}) => {
  // Create new option
  const createNewOption = (id) => {
    const data = {
      id: uuid(),
      value: "",
    };
    addOption(id, data);
  };

  return (
    <Fragment>
      {item.saved ? (
        <>
          <div className="relative border p-4 rounded-md shadow-md">
            <div className="mb-4">
              <label className="block text-lg font-medium">
                {item.required && "* "}
                {index + 1 + ". " + item.value}
              </label>
            </div>
            <div>
              {item.options &&
                item.options?.length > 0 &&
                item.options?.map((opt) => (
                  <div className="flex items-center my-2" key={opt.id}>
                    <Checkbox disabled className="mr-2" />
                    <p className="text-base">{opt?.value}</p>
                  </div>
                ))}
            </div>
            <div className="absolute top-2 right-2 flex gap-2">
              <Button
                size="sm"
                color="blue"
                onClick={() => handleSave(item.id)}
              >
                Edit
              </Button>
              <Button size="sm" color="red" onClick={() => deleteEl(item.id)}>
                Delete
              </Button>
              <Button
                size="sm"
                color="gray"
                onClick={() => duplicateElement(item.id, item.type)}
              >
                Duplicate
              </Button>
            </div>
          </div>
        </>
      ) : (
        <div className="p-4 border rounded-md shadow-md bg-white">
          <div className="mb-4 flex items-center gap-4">
            <label className="text-lg">Q.{index + 1}.</label>
            <Input
              type="text"
              defaultValue={item.value}
              onBlur={(e) => handleValue(item.id, e)}
              label="Enter your question"
              required={item.required}
            />
          </div>
          <div className="mb-4">
            {item.options &&
              item.options?.length > 0 &&
              item.options?.map((opt, key) => (
                <div className="flex items-center gap-2 mb-2" key={opt.id}>
                  <Checkbox disabled className="mr-2" />
                  <Input
                    type="text"
                    defaultValue={opt?.value}
                    onBlur={(e) =>
                      handleOptionValues(item?.id, opt?.id, e.target.value)
                    }
                    label={`Enter an answer choice ${key + 1}`}
                  />
                  <Button
                    size="sm"
                    color="green"
                    onClick={() => createNewOption(item.id)}
                  >
                    <FiPlusCircle className="text-lg" />
                  </Button>
                  <Button
                    size="sm"
                    color="red"
                    onClick={() => deleteOption(item.id, opt?.id)}
                  >
                    <IoMdRemoveCircleOutline className="text-lg" />
                  </Button>
                </div>
              ))}
          </div>
          <div className="mb-4">
            <Select
              label="Element Type"
              value={item.type}
              onChange={(value) => handleElType(item.id, value)}
            >
              {formEl &&
                formEl.map((el, key) => (
                  <Option key={key} value={el.value}>
                    {el.label}
                  </Option>
                ))}
            </Select>
          </div>

          <hr className="my-4" />
          <div className="flex justify-between items-center">
            <div>
              <Switch
                label="Required"
                checked={item.required}
                onChange={() => handleRequired(item.id)}
              />
            </div>
            <div className="flex gap-2">
              <Button
                size="sm"
                variant="outlined"
                color="red"
                onClick={() => deleteEl(item.id)}
              >
                Cancel
              </Button>
              <Button
                size="sm"
                className="bg-[#000080]"
                onClick={() => handleSave(item.id)}
              >
                Save
              </Button>
              <Button
                size="sm"
                color="gray"
                onClick={() => duplicateElement(item.id, item.type)}
              >
                <FaCopy />
              </Button>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default CheckBoxInput;
